<template>
  <main class="page document-page">
    <div class="document-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Управление</span>
        </li>
      </ul>
      <h1 class="document-page__title">Структура учреждения</h1>
      <div class="document-page__content">
        <div class="document-page__search">
          <i aria-hidden="true" class="document-page__search__icon">
            <search-icon/>
          </i>
          <input autocomplete="off" class="document-page__search__input" placeholder="Поиск по имени, фамилии, должности" title="Поиск по имени, фамилии, должности" type="text" v-model="search"/>
        </div>
        <ul class="document-page__management">
          <li :key="index" class="document-page__management__li" v-for="(management, index) in managements">
            <a class="document-page__management__link" href="#">
              <img :alt="`${management.surname} ${management.name} ${management.patronymic}`" :src="getImg(management) | findSource($store.state.api)" class="document-page__management__image"/>
              <div class="document-page__management__info">
                <h3>{{ `${management.surname} ${management.name} ${management.patronymic}` }}</h3>
                <span>{{ management.profession }}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import SearchIcon from 'components/svg/SearchIcon.vue'

export default {
  async asyncData ({ store }) {
    await store.dispatch('MANAGEMENTS_PAGE')
  },
  name: 'ManagementPage',
  components: { SearchIcon },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    managements () {
      return this.search.length === 0 ? this.$store.state.managements : this.$store.state.managements.filter(item => {
        return (item.surname + ' ' + item.name + ' ' + item.patronymic + ' ' + item.profession).toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    getImg(data) {
      if (data.img_original && data.img_original.length && data.img_original[0].get_img && data.img_original[0].get_img.url) {
        return data.img_original
      }
      if (data.img1250 && data.img1250.length && data.img1250[0].get_img && data.img1250[0].get_img.url) {
        return data.img1250
      }
      if (data.img650 && data.img650.length && data.img650[0].get_img && data.img650[0].get_img.url) {
        return data.img650
      }
      if (data.img350 && data.img350.length && data.img350[0].get_img && data.img350[0].get_img.url) {
        return data.img350
      }
      if (data.img150 && data.img150.length && data.img150[0].get_img && data.img150[0].get_img.url) {
        return data.img150
      }
      return [];
    }
  },
  metaInfo () {
    return this.$seo(
      'common',
      'Управление',
      'управление образования, образование',
      '',
      'Управление',
      '',
      ''
    )
  }
}
</script>
